module.exports = __webpack_public_path__ + "static/media/whiteHeartIcon.3bb95068.svg";